// imports shared across all ORA templates
require('../ora/base/imports');

// modules
require('../site_scripts/mtc_finance_video_overlay');
require('../site_scripts/mtc_youtube_overlay');
require('../site_scripts/mtc_read_more');
require('../global/tabs');
require('../global/accordion');
require('../search/toggle-finance-example');
require('../ora/modules/colour-picker');
require('../ora/modules/gallery-slider');
require('../ora/modules/video-overlay');

// ORA page styles
require('../../styles/entry/ora.less')
